/* Bilingual content for Tirzepatide, NAD+, and Sermorelin landing pages */

export const LANDING_CONTENT = {
  en: {
    tirzepatide: {
      nav: {
        benefits: "Benefits",
        howItWorks: "How It Works",
        whyUs: "Why Us",
        getStarted: "Get Started"
      },
      stickyBar: {
        text: "Physician-supervised medical weight loss.",
        cta: "Get Started"
      },
      hero: {
        eyebrow: "Physician-Prescribed Weight Loss",
        h1: "Lose the Weight.",
        h1Em: "Keep It Off.",
        sub: "Tirzepatide is the most clinically advanced weight loss therapy available — a dual-action GLP-1 / GIP peptide prescribed by our medical team and delivered to your door. Real results, real medicine.",
        cta: "Get Started",
        micro: "Under 10 min · Free physician review · No commitment",
        trust: ["Doctor Supervised", "FDA-Registered Pharmacy", "HIPAA Secure", "Ships Nationwide"],
        badge: "Tirzepatide · GLP-1 / GIP"
      },
      benefits: {
        label: "Why Tirzepatide",
        title: "The most powerful weight loss",
        titleEm: "available today.",
        subtitle: "Tirzepatide works on two metabolic receptors simultaneously — GLP-1 and GIP — making it more effective than any single-action weight loss medication. Clinical trials showed patients losing up to 22% of body weight.",
        items: [
          { icon: "🔥", title: "Dual-Action Fat Burning", desc: "Activates both GLP-1 and GIP receptors simultaneously — targeting appetite, fat storage, and metabolic rate at the same time." },
          { icon: "🍽️", title: "Powerful Appetite Suppression", desc: "Slows gastric emptying and signals fullness to your brain — dramatically reducing hunger without willpower or restriction." },
          { icon: "🩸", title: "Blood Sugar Regulation", desc: "Improves insulin sensitivity and lowers blood glucose — reducing the metabolic dysfunction that drives weight gain and inflammation." },
          { icon: "📉", title: "Sustainable, Long-Term Results", desc: "Compounded with Niacinamide (Vitamin B3) to support energy metabolism and reduce side effects for better long-term tolerance." }
        ],
        statNum: "22%",
        statLabel: "Average Body Weight Lost",
        statSub: "In clinical trials — the highest of any weight loss therapy studied to date.",
        ctaNote: "Free physician review · No obligation"
      },
      formula: {
        label: "The Formula",
        title: "Tirzepatide + Niacinamide.",
        titleEm: "Engineered for results.",
        subtitle: "Our compounded formulation pairs clinically-proven Tirzepatide with Niacinamide (Vitamin B3) — improving tolerability, supporting energy metabolism, and maximizing therapeutic outcomes. Available in multiple dosage strengths, titrated gradually to your needs.",
        cards: [
          { icon: "💉", title: "How It's Administered", desc: "Weekly subcutaneous injection into the abdomen, thigh, or upper arm. Doses are gradually titrated upward over several weeks to optimize results and minimize side effects. Most patients inject once per week on the same day." },
          { icon: "📦", title: "Available Strengths", table: [
            ["Tirzepatide / Niacinamide", "17 / 2 mg/mL", "4 mL"],
            ["Tirzepatide / Niacinamide", "8 / 2 mg/mL", "2.5 mL"],
            ["Tirzepatide / Niacinamide", "17 / 2 mg/mL", "2 mL"]
          ], tableNote: "Your physician will determine the most appropriate formulation based on your individual goals and response." },
          { icon: "⚠️", title: "Who Is It For?", desc: "Adults seeking medical weight loss with physician supervision. Ideal for those who have struggled with diet and exercise alone, have metabolic or blood sugar concerns, or have a BMI indicating medical need. A full intake evaluation is required prior to prescribing." },
          { icon: "🏭", title: "Pharmacy Standards", desc: "Compounded exclusively at FDA-registered, 503A pharmacies using pharmaceutical-grade ingredients sourced from FDA-registered suppliers. Prepared in sterile conditions to strict quality standards. Not an FDA-approved drug — compounded for individual patient use under physician prescription." }
        ],
        ctaNote: "Start your free medical evaluation"
      },
      howItWorks: {
        label: "The Process",
        title: "3 Steps to Treatment.",
        titleEm: "No clinic required.",
        subtitle: "From intake to delivery in days — not weeks. Our medical team handles everything.",
        steps: [
          { num: "01", title: "Fill Out Your Medical Form", desc: "A brief, HIPAA-secure health questionnaire. Takes under 10 minutes and can be completed from your phone, anywhere." },
          { num: "02", title: "Get Approved by a Doctor", desc: "A licensed physician reviews your profile and determines the right Tirzepatide dosage and titration plan for your goals." },
          { num: "03", title: "Receive It at Your Door", desc: "Your medication is compounded at an FDA-registered pharmacy and shipped discreetly — directly to your home, ready to use." }
        ],
        ctaNote: "Takes 10 minutes · Physician review included"
      },
      trust: {
        label: "You're Protected",
        title: "Medical-Grade Care.",
        titleEm: "Zero Compromises.",
        items: [
          { title: "Doctor Supervised", desc: "Every plan reviewed and approved by a licensed physician before any order is placed." },
          { title: "FDA-Registered Pharmacies", desc: "Compounded in fully accredited, FDA-registered facilities to the highest purity standards." },
          { title: "HIPAA Secure", desc: "Your health data is fully encrypted. Discreet packaging — no medical labels on the outside." },
          { title: "Delivered to Your Door", desc: "Ships nationwide. Ongoing physician check-ins included. We're with you every step." }
        ]
      },
      finalCta: {
        label: "One Step Away",
        title: "Your Best Body Starts",
        titleEm: "Right Now.",
        subtitle: "Fill out your medical intake form in under 10 minutes. Our physician team will review it and reach out with your personalized Tirzepatide plan. No obligation, no clinic visit.",
        meta: ["10-Minute Intake", "No Commitment", "100% Private", "Ships Nationwide"]
      },
      footer: {
        links: ["Privacy Policy", "Terms of Service", "Contact Us"],
        copy: "© 2026 AntiAging by BB · antiagingbybb.com · All rights reserved."
      },
      disclaimer: "* These statements have not been evaluated by the Food and Drug Administration. Tirzepatide / Niacinamide Injection is a compounded medication and is not FDA-approved. Compounded medications are prepared for individual patient use pursuant to a valid prescription. Results may vary. All treatments require physician evaluation and approval. Individual results are not guaranteed."
    },
    nad: {
      nav: {
        benefits: "Benefits",
        howItWorks: "How It Works",
        whyUs: "Why Us",
        getStarted: "Get Started"
      },
      stickyBar: {
        text: "Physician-supervised. Delivered to you.",
        cta: "Get Started"
      },
      hero: {
        eyebrow: "NAD+ 1000mg — Now Available",
        h1: "Feel 10 Years Younger.",
        h1Em: "Starting This Week.",
        sub: "The highest-potency NAD+ therapy available — prescribed by our licensed medical team and delivered directly to your door. No clinic visits. No waiting rooms.",
        cta: "Get Started",
        micro: "Under 10 min · Free physician review · No commitment",
        trust: ["Doctor Supervised", "FDA-Registered Pharmacy", "HIPAA Secure", "Ships Nationwide"],
        badge: "NAD+ · 1000mg"
      },
      benefits: {
        label: "Why NAD+",
        title: "Your cells are running on ",
        titleEm: "empty.",
        titlePost: "NAD+ refuels them.",
        subtitle: "After 30, your NAD+ levels drop by up to 50%. That's why you feel tired, foggy, and slower to recover. Our 1000mg formula restores what time takes away — at the cellular level.",
        items: [
          { icon: "⚡", title: "All-Day Energy — Without Caffeine", desc: "Directly fuels mitochondria for sustained energy that doesn't crash. No jitters, no dependency." },
          { icon: "🧠", title: "Sharper Mind & Focus", desc: "Supports neuronal function and neurotransmitter production. Faster recall, clearer thinking, improved mental stamina." },
          { icon: "🔬", title: "Cellular Anti-Aging", desc: "Activates sirtuins — the longevity proteins that repair DNA, reduce oxidative stress, and slow biological aging." },
          { icon: "💪", title: "Faster Recovery", desc: "Restores ATP production to accelerate muscle repair, improve sleep quality, and bounce back faster from exertion." }
        ],
        statNum: "50%",
        statLabel: "NAD+ Decline by Age 50",
        statSub: "Restoring levels is the #1 intervention in longevity science today.",
        ctaNote: "Free physician review · No obligation"
      },
      howItWorks: {
        label: "The Process",
        title: "3 Steps to Treatment.",
        titleEm: "No clinic required.",
        subtitle: "From intake to delivery in days — not weeks. Our medical team handles everything.",
        steps: [
          { num: "01", title: "Fill Out Your Medical Form", desc: "A brief, HIPAA-secure questionnaire. Takes under 10 minutes and can be done from your phone, anywhere." },
          { num: "02", title: "Get Approved by a Doctor", desc: "A licensed physician reviews your profile and creates a personalized NAD+ protocol tailored to your goals." },
          { num: "03", title: "Receive It at Your Door", desc: "Your NAD+ is compounded at an FDA-registered pharmacy and shipped discreetly — directly to your home." }
        ],
        ctaNote: "Takes 10 minutes · Physician review included"
      },
      trust: {
        label: "You're Protected",
        title: "Medical-Grade Care.",
        titleEm: "Zero Compromises.",
        items: [
          { title: "Doctor Supervised", desc: "Every plan reviewed and approved by a licensed physician before any order is placed." },
          { title: "FDA-Registered Pharmacies", desc: "Compounded in fully accredited, FDA-registered facilities to the highest purity standards." },
          { title: "HIPAA Secure", desc: "Your health data is fully encrypted. Discreet packaging — no medical labels on the outside." },
          { title: "Delivered to Your Door", desc: "Ships nationwide. Ongoing physician check-ins included. We're with you every step." }
        ]
      },
      finalCta: {
        label: "One Step Away",
        title: "Your Body Deserves",
        titleEm: "Better Fuel.",
        subtitle: "Fill out your medical intake form in under 10 minutes. Our physician team will review it and reach out with your personalized plan. No obligation, no clinic visit.",
        meta: ["10-Minute Intake", "No Commitment", "100% Private", "Ships Nationwide"]
      },
      footer: {
        links: ["Privacy Policy", "Terms of Service", "Contact Us"],
        copy: "© 2026 AntiAging by BB · antiagingbybb.com · All rights reserved."
      },
      disclaimer: "* These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. Results may vary. All treatments require physician evaluation and approval. Compounded medications are not FDA-approved. Individual results are not guaranteed."
    },
    sermorelin: {
      nav: {
        benefits: "Benefits",
        formula: "The Formula",
        howItWorks: "How It Works",
        getStarted: "Get Started"
      },
      stickyBar: {
        text: "Physician-supervised HGH therapy. Delivered to you.",
        cta: "Get Started"
      },
      hero: {
        eyebrow: "Growth Hormone Therapy — Physician Prescribed",
        h1: "Age Backwards.",
        h1Em: "From the Inside Out.",
        sub: "Sermorelin stimulates your pituitary to produce more of your own growth hormone — rebuilding lean muscle, burning fat, deepening sleep, and turning back the biological clock. No synthetic hormones. Just your body, optimized.",
        cta: "Get Started",
        micro: "Under 10 min · Free physician review · No commitment",
        trust: ["Doctor Supervised", "FDA-Registered Pharmacy", "HIPAA Secure", "Ships Nationwide"],
        badge: "Sermorelin · 6 / 9 / 15 mg"
      },
      benefits: {
        label: "Why Sermorelin",
        title: "Your growth hormone peaks",
        titleEm: "falls every year after.",
        titlePost: "at 20 — and ",
        subtitle: "By your 40s, GH levels have dropped by more than half. Sermorelin works with your own biology — stimulating your pituitary to produce GH naturally, the way it did when you were younger. The results are profound and lasting.",
        items: [
          { icon: "💪", title: "Lean Muscle Rebuilding", desc: "Growth hormone is the primary driver of muscle protein synthesis. Restoring levels helps rebuild and preserve lean body mass as you age." },
          { icon: "🔥", title: "Accelerated Fat Burning", desc: "GH triggers lipolysis — the breakdown of stored fat for energy. Patients commonly see significant reductions in stubborn body fat, especially abdominal." },
          { icon: "😴", title: "Deeper, Restorative Sleep", desc: "Sermorelin is dosed at bedtime to mimic your body's natural GH rhythm. Patients report dramatically improved sleep quality within weeks." },
          { icon: "✨", title: "Skin, Hair & Vitality", desc: "Higher GH/IGF-1 levels support collagen production, improve skin texture, strengthen hair, and restore the energy and drive of your younger years." }
        ],
        statNum: "50%",
        statLabel: "GH Decline by Age 40",
        statSub: "Sermorelin restores your body's own production — naturally and safely.",
        ctaNote: "Free physician review · No obligation"
      },
      formula: {
        label: "The Formula",
        title: "Physiologic HGH stimulation.",
        titleEm: "Not replacement — regeneration.",
        subtitle: "Sermorelin is a synthetic analog of the first 29 amino acids of natural GHRH. Unlike direct HGH injections, it works upstream — prompting your own pituitary to release GH in its natural pulsatile rhythm, with built-in safety feedback mechanisms.",
        cards: [
          { icon: "💉", title: "How It's Administered", desc: "Daily subcutaneous injection, typically once at bedtime to align with your body's natural nocturnal GH release. The injection is small (insulin-style syringe) and most patients self-administer at home after brief instruction. Sites are rotated between the abdomen, thigh, and upper arm." },
          { icon: "📦", title: "Available Strengths", table: [
            ["Sermorelin Acetate", "6 mg", "Lyophilized vial"],
            ["Sermorelin Acetate", "9 mg", "Lyophilized vial"],
            ["Sermorelin Acetate", "15 mg", "Lyophilized vial"]
          ], tableNote: "Powder is reconstituted with bacteriostatic water before use. Your physician determines the right strength and dosing protocol for your individual needs." },
          { icon: "🔬", title: "How It Differs from HGH", desc: "Direct HGH injections bypass your body's natural feedback loop, which can suppress your own production and cause side effects at higher doses (joint pain, fluid retention, insulin resistance). Sermorelin works with your endocrine system — your body still controls how much GH is released, making it safer and more physiologic at therapeutic doses." },
          { icon: "🏭", title: "Pharmacy Standards", desc: "Compounded exclusively at FDA-registered 503A pharmacies using pharmaceutical-grade ingredients from FDA-registered suppliers. Prepared as a sterile lyophilized powder in individual patient vials. This is a compounded medication — not an FDA-approved drug — and is dispensed pursuant to a valid physician prescription." }
        ],
        ctaNote: "Start your free medical evaluation"
      },
      howItWorks: {
        label: "The Process",
        title: "3 Steps to Treatment.",
        titleEm: "No clinic required.",
        subtitle: "From intake to delivery in days — not weeks. Our medical team handles everything.",
        steps: [
          { num: "01", title: "Fill Out Your Medical Form", desc: "A brief, HIPAA-secure health questionnaire. Takes under 10 minutes and can be completed from your phone, anywhere." },
          { num: "02", title: "Get Approved by a Doctor", desc: "A licensed physician reviews your profile and determines the right Sermorelin strength and dosing protocol for your goals." },
          { num: "03", title: "Receive It at Your Door", desc: "Your Sermorelin is compounded at an FDA-registered pharmacy and shipped discreetly — directly to your home, ready to reconstitute and use." }
        ],
        ctaNote: "Takes 10 minutes · Physician review included"
      },
      trust: {
        label: "You're Protected",
        title: "Medical-Grade Care.",
        titleEm: "Zero Compromises.",
        items: [
          { title: "Doctor Supervised", desc: "Every plan reviewed and approved by a licensed physician before any order is placed." },
          { title: "FDA-Registered Pharmacies", desc: "Compounded in fully accredited, FDA-registered facilities to the highest purity standards." },
          { title: "HIPAA Secure", desc: "Your health data is fully encrypted. Discreet packaging — no medical labels on the outside." },
          { title: "Delivered to Your Door", desc: "Ships nationwide. Ongoing physician check-ins included. We're with you every step." }
        ]
      },
      finalCta: {
        label: "One Step Away",
        title: "Your Best Years",
        titleEm: "Are Ahead of You.",
        subtitle: "Fill out your medical intake form in under 10 minutes. Our physician team will review it and reach out with your personalized Sermorelin plan. No obligation, no clinic visit.",
        meta: ["10-Minute Intake", "No Commitment", "100% Private", "Ships Nationwide"]
      },
      footer: {
        links: ["Privacy Policy", "Terms of Service", "Contact Us"],
        copy: "© 2026 AntiAging by BB · antiagingbybb.com · All rights reserved."
      },
      disclaimer: "* Sermorelin Acetate is a compounded medication and is not FDA-approved. Compounded medications are prepared for individual patient use pursuant to a valid physician prescription. These statements have not been evaluated by the Food and Drug Administration. Results may vary. All treatments require physician evaluation and approval. Individual results are not guaranteed."
    }
  },
  es: {
    tirzepatide: {
      nav: {
        benefits: "Beneficios",
        howItWorks: "Cómo Funciona",
        whyUs: "Por Qué Nosotros",
        getStarted: "Comenzar"
      },
      stickyBar: {
        text: "Pérdida de peso médica supervisada por médicos.",
        cta: "Comenzar"
      },
      hero: {
        eyebrow: "Pérdida de Peso Prescrita por Médicos",
        h1: "Pierde el Peso.",
        h1Em: "Mantenlo Fuera.",
        sub: "Tirzepatida es la terapia de pérdida de peso clínicamente más avanzada disponible — un péptido de doble acción GLP-1 / GIP prescrito por nuestro equipo médico y entregado a tu puerta. Resultados reales, medicina real.",
        cta: "Comenzar",
        micro: "Menos de 10 min · Revisión médica gratuita · Sin compromiso",
        trust: ["Supervisado por Médico", "Farmacia Registrada FDA", "HIPAA Seguro", "Envío Nacional"],
        badge: "Tirzepatida · GLP-1 / GIP"
      },
      benefits: {
        label: "Por Qué Tirzepatida",
        title: "La pérdida de peso más poderosa",
        titleEm: "disponible hoy.",
        subtitle: "Tirzepatida funciona en dos receptores metabólicos simultáneamente — GLP-1 y GIP — haciéndola más efectiva que cualquier medicamento de pérdida de peso de acción única. Los ensayos clínicos mostraron pacientes perdiendo hasta el 22% del peso corporal.",
        items: [
          { icon: "🔥", title: "Quema de Grasa de Doble Acción", desc: "Activa los receptores GLP-1 y GIP simultáneamente — enfocándose en el apetito, el almacenamiento de grasa y la tasa metabólica al mismo tiempo." },
          { icon: "🍽️", title: "Poderosa Supresión del Apetito", desc: "Ralentiza el vaciado gástrico y señala saciedad a tu cerebro — reduciendo dramáticamente el hambre sin fuerza de voluntad o restricción." },
          { icon: "🩸", title: "Regulación de Azúcar en Sangre", desc: "Mejora la sensibilidad a la insulina y reduce la glucosa en sangre — reduciendo la disfunción metabólica que impulsa el aumento de peso y la inflamación." },
          { icon: "📉", title: "Resultados Sostenibles a Largo Plazo", desc: "Compuesta con Niacinamida (Vitamina B3) para apoyar el metabolismo energético y reducir efectos secundarios para mejor tolerancia a largo plazo." }
        ],
        statNum: "22%",
        statLabel: "Peso Corporal Promedio Perdido",
        statSub: "En ensayos clínicos — el más alto de cualquier terapia de pérdida de peso estudiada hasta la fecha.",
        ctaNote: "Revisión médica gratuita · Sin obligación"
      },
      formula: {
        label: "La Fórmula",
        title: "Tirzepatida + Niacinamida.",
        titleEm: "Diseñada para resultados.",
        subtitle: "Nuestra formulación compuesta combina Tirzepatida clínicamente probada con Niacinamida (Vitamina B3) — mejorando la tolerabilidad, apoyando el metabolismo energético y maximizando los resultados terapéuticos. Disponible en múltiples concentraciones de dosificación, tituladas gradualmente a tus necesidades.",
        cards: [
          { icon: "💉", title: "Cómo se Administra", desc: "Inyección subcutánea semanal en el abdomen, muslo o brazo superior. Las dosis se titulan gradualmente hacia arriba durante varias semanas para optimizar resultados y minimizar efectos secundarios. La mayoría de pacientes se inyectan una vez por semana el mismo día." },
          { icon: "📦", title: "Concentraciones Disponibles", table: [
            ["Tirzepatida / Niacinamida", "17 / 2 mg/mL", "4 mL"],
            ["Tirzepatida / Niacinamida", "8 / 2 mg/mL", "2.5 mL"],
            ["Tirzepatida / Niacinamida", "17 / 2 mg/mL", "2 mL"]
          ], tableNote: "Tu médico determinará la formulación más apropiada basándose en tus objetivos individuales y respuesta." },
          { icon: "⚠️", title: "¿Para Quién Es?", desc: "Adultos que buscan pérdida de peso médica con supervisión de un médico. Ideal para aquellos que han luchado solo con dieta y ejercicio, tienen preocupaciones metabólicas o de azúcar en sangre, o tienen un IMC que indica necesidad médica. Se requiere una evaluación de admisión completa antes de prescribir." },
          { icon: "🏭", title: "Estándares de Farmacia", desc: "Compuesto exclusivamente en farmacias 503A registradas por la FDA utilizando ingredientes de grado farmacéutico de proveedores registrados por la FDA. Preparado en condiciones estériles con estrictos estándares de calidad. No es un medicamento aprobado por la FDA — compuesto para uso individual del paciente bajo prescripción médica." }
        ],
        ctaNote: "Comienza tu evaluación médica gratuita"
      },
      howItWorks: {
        label: "El Proceso",
        title: "3 Pasos para el Tratamiento.",
        titleEm: "No se requiere clínica.",
        subtitle: "Desde la admisión hasta la entrega en días — no semanas. Nuestro equipo médico maneja todo.",
        steps: [
          { num: "01", title: "Completa tu Formulario Médico", desc: "Un breve cuestionario de salud seguro HIPAA. Toma menos de 10 minutos y se puede completar desde tu teléfono, en cualquier lugar." },
          { num: "02", title: "Obtén la Aprobación de un Médico", desc: "Un médico licenciado revisa tu perfil y determina la dosificación de Tirzepatida correcta y el plan de titulación para tus objetivos." },
          { num: "03", title: "Recíbelo en tu Puerta", desc: "Tu medicamento se compone en una farmacia registrada por la FDA y se envía discretamente — directamente a tu casa, listo para usar." }
        ],
        ctaNote: "Toma 10 minutos · Revisión médica incluida"
      },
      trust: {
        label: "Estás Protegido",
        title: "Cuidado de Grado Médico.",
        titleEm: "Cero Compromisos.",
        items: [
          { title: "Supervisado por Médico", desc: "Cada plan revisado y aprobado por un médico licenciado antes de que se realice cualquier pedido." },
          { title: "Farmacias Registradas FDA", desc: "Compuesto en instalaciones totalmente acreditadas y registradas por la FDA con los más altos estándares de pureza." },
          { title: "HIPAA Seguro", desc: "Tus datos de salud están completamente encriptados. Embalaje discreto — sin etiquetas médicas en el exterior." },
          { title: "Entregado a tu Puerta", desc: "Envío a nivel nacional. Consultas médicas continuas incluidas. Estamos contigo en cada paso." }
        ]
      },
      finalCta: {
        label: "A Un Paso",
        title: "Tu Mejor Cuerpo Comienza",
        titleEm: "Ahora Mismo.",
        subtitle: "Completa tu formulario de admisión médica en menos de 10 minutos. Nuestro equipo de médicos lo revisará y se comunicará contigo con tu plan personalizado de Tirzepatida. Sin obligación, sin visita a clínica.",
        meta: ["Admisión de 10 Minutos", "Sin Compromiso", "100% Privado", "Envío Nacional"]
      },
      footer: {
        links: ["Política de Privacidad", "Términos de Servicio", "Contáctanos"],
        copy: "© 2026 AntiAging by BB · antiagingbybb.com · Todos los derechos reservados."
      },
      disclaimer: "* Estas declaraciones no han sido evaluadas por la Administración de Alimentos y Medicamentos. La Inyección de Tirzepatida / Niacinamida es un medicamento compuesto y no está aprobado por la FDA. Los medicamentos compuestos se preparan para uso individual del paciente conforme a una prescripción válida. Los resultados pueden variar. Todos los tratamientos requieren evaluación y aprobación médica. Los resultados individuales no están garantizados."
    },
    nad: {
      nav: {
        benefits: "Beneficios",
        howItWorks: "Cómo Funciona",
        whyUs: "Por Qué Nosotros",
        getStarted: "Comenzar"
      },
      stickyBar: {
        text: "Supervisado por médicos. Entregado a ti.",
        cta: "Comenzar"
      },
      hero: {
        eyebrow: "NAD+ 1000mg — Ahora Disponible",
        h1: "Siéntete 10 Años Más Joven.",
        h1Em: "Comenzando Esta Semana.",
        sub: "La terapia de NAD+ de mayor potencia disponible — prescrita por nuestro equipo médico licenciado y entregada directamente a tu puerta. Sin visitas a clínicas. Sin salas de espera.",
        cta: "Comenzar",
        micro: "Menos de 10 min · Revisión médica gratuita · Sin compromiso",
        trust: ["Supervisado por Médico", "Farmacia Registrada FDA", "HIPAA Seguro", "Envío Nacional"],
        badge: "NAD+ · 1000mg"
      },
      benefits: {
        label: "Por Qué NAD+",
        title: "Tus células están funcionando en ",
        titleEm: "vacío.",
        titlePost: "NAD+ las recarga.",
        subtitle: "Después de los 30, tus niveles de NAD+ caen hasta un 50%. Por eso te sientes cansado, confuso y más lento para recuperarte. Nuestra fórmula de 1000mg restaura lo que el tiempo quita — a nivel celular.",
        items: [
          { icon: "⚡", title: "Energía Todo el Día — Sin Cafeína", desc: "Alimenta directamente las mitocondrias para energía sostenida que no se desploma. Sin nerviosismo, sin dependencia." },
          { icon: "🧠", title: "Mente y Enfoque Más Agudos", desc: "Apoya la función neuronal y la producción de neurotransmisores. Recuerdo más rápido, pensamiento más claro, resistencia mental mejorada." },
          { icon: "🔬", title: "Anti-Envejecimiento Celular", desc: "Activa sirtuinas — las proteínas de longevidad que reparan el ADN, reducen el estrés oxidativo y ralentizan el envejecimiento biológico." },
          { icon: "💪", title: "Recuperación Más Rápida", desc: "Restaura la producción de ATP para acelerar la reparación muscular, mejorar la calidad del sueño y recuperarse más rápido del esfuerzo." }
        ],
        statNum: "50%",
        statLabel: "Disminución de NAD+ a los 50 Años",
        statSub: "Restaurar los niveles es la intervención #1 en la ciencia de la longevidad hoy.",
        ctaNote: "Revisión médica gratuita · Sin obligación"
      },
      howItWorks: {
        label: "El Proceso",
        title: "3 Pasos para el Tratamiento.",
        titleEm: "No se requiere clínica.",
        subtitle: "Desde la admisión hasta la entrega en días — no semanas. Nuestro equipo médico maneja todo.",
        steps: [
          { num: "01", title: "Completa tu Formulario Médico", desc: "Un breve cuestionario seguro HIPAA. Toma menos de 10 minutos y se puede hacer desde tu teléfono, en cualquier lugar." },
          { num: "02", title: "Obtén la Aprobación de un Médico", desc: "Un médico licenciado revisa tu perfil y crea un protocolo de NAD+ personalizado adaptado a tus objetivos." },
          { num: "03", title: "Recíbelo en tu Puerta", desc: "Tu NAD+ se compone en una farmacia registrada por la FDA y se envía discretamente — directamente a tu casa." }
        ],
        ctaNote: "Toma 10 minutos · Revisión médica incluida"
      },
      trust: {
        label: "Estás Protegido",
        title: "Cuidado de Grado Médico.",
        titleEm: "Cero Compromisos.",
        items: [
          { title: "Supervisado por Médico", desc: "Cada plan revisado y aprobado por un médico licenciado antes de que se realice cualquier pedido." },
          { title: "Farmacias Registradas FDA", desc: "Compuesto en instalaciones totalmente acreditadas y registradas por la FDA con los más altos estándares de pureza." },
          { title: "HIPAA Seguro", desc: "Tus datos de salud están completamente encriptados. Embalaje discreto — sin etiquetas médicas en el exterior." },
          { title: "Entregado a tu Puerta", desc: "Envío a nivel nacional. Consultas médicas continuas incluidas. Estamos contigo en cada paso." }
        ]
      },
      finalCta: {
        label: "A Un Paso",
        title: "Tu Cuerpo Merece",
        titleEm: "Mejor Combustible.",
        subtitle: "Completa tu formulario de admisión médica en menos de 10 minutos. Nuestro equipo de médicos lo revisará y se comunicará contigo con tu plan personalizado. Sin obligación, sin visita a clínica.",
        meta: ["Admisión de 10 Minutos", "Sin Compromiso", "100% Privado", "Envío Nacional"]
      },
      footer: {
        links: ["Política de Privacidad", "Términos de Servicio", "Contáctanos"],
        copy: "© 2026 AntiAging by BB · antiagingbybb.com · Todos los derechos reservados."
      },
      disclaimer: "* Estas declaraciones no han sido evaluadas por la Administración de Alimentos y Medicamentos. Este producto no está destinado a diagnosticar, tratar, curar o prevenir ninguna enfermedad. Los resultados pueden variar. Todos los tratamientos requieren evaluación y aprobación médica. Los medicamentos compuestos no están aprobados por la FDA. Los resultados individuales no están garantizados."
    },
    sermorelin: {
      nav: {
        benefits: "Beneficios",
        formula: "La Fórmula",
        howItWorks: "Cómo Funciona",
        getStarted: "Comenzar"
      },
      stickyBar: {
        text: "Terapia de HGH supervisada por médicos. Entregada a ti.",
        cta: "Comenzar"
      },
      hero: {
        eyebrow: "Terapia de Hormona de Crecimiento — Prescrita por Médico",
        h1: "Envejece Hacia Atrás.",
        h1Em: "Desde Adentro Hacia Afuera.",
        sub: "Sermorelina estimula tu pituitaria para producir más de tu propia hormona de crecimiento — reconstruyendo músculo magro, quemando grasa, profundizando el sueño y retrocediendo el reloj biológico. Sin hormonas sintéticas. Solo tu cuerpo, optimizado.",
        cta: "Comenzar",
        micro: "Menos de 10 min · Revisión médica gratuita · Sin compromiso",
        trust: ["Supervisado por Médico", "Farmacia Registrada FDA", "HIPAA Seguro", "Envío Nacional"],
        badge: "Sermorelina · 6 / 9 / 15 mg"
      },
      benefits: {
        label: "Por Qué Sermorelina",
        title: "Tu hormona de crecimiento alcanza su pico",
        titleEm: "cae cada año después.",
        titlePost: "a los 20 — y ",
        subtitle: "Para los 40, los niveles de GH han caído más de la mitad. Sermorelina trabaja con tu propia biología — estimulando tu pituitaria para producir GH naturalmente, de la manera que lo hacía cuando eras más joven. Los resultados son profundos y duraderos.",
        items: [
          { icon: "💪", title: "Reconstrucción de Músculo Magro", desc: "La hormona de crecimiento es el impulsor principal de la síntesis de proteína muscular. Restaurar los niveles ayuda a reconstruir y preservar la masa corporal magra a medida que envejeces." },
          { icon: "🔥", title: "Quema de Grasa Acelerada", desc: "GH desencadena la lipólisis — la descomposición de grasa almacenada para energía. Los pacientes comúnmente ven reducciones significativas en grasa corporal obstinada, especialmente abdominal." },
          { icon: "😴", title: "Sueño Más Profundo y Reparador", desc: "Sermorelina se dosifica al acostarse para imitar el ritmo natural de GH de tu cuerpo. Los pacientes reportan calidad de sueño dramáticamente mejorada en semanas." },
          { icon: "✨", title: "Piel, Cabello y Vitalidad", desc: "Niveles más altos de GH/IGF-1 apoyan la producción de colágeno, mejoran la textura de la piel, fortalecen el cabello y restauran la energía y el impulso de tus años más jóvenes." }
        ],
        statNum: "50%",
        statLabel: "Disminución de GH a los 40 Años",
        statSub: "Sermorelina restaura la producción propia de tu cuerpo — naturalmente y de forma segura.",
        ctaNote: "Revisión médica gratuita · Sin obligación"
      },
      formula: {
        label: "La Fórmula",
        title: "Estimulación fisiológica de HGH.",
        titleEm: "No reemplazo — regeneración.",
        subtitle: "Sermorelina es un análogo sintético de los primeros 29 aminoácidos de GHRH natural. A diferencia de las inyecciones directas de HGH, funciona aguas arriba — impulsando tu propia pituitaria a liberar GH en su ritmo pulsátil natural, con mecanismos de retroalimentación de seguridad incorporados.",
        cards: [
          { icon: "💉", title: "Cómo se Administra", desc: "Inyección subcutánea diaria, típicamente una vez al acostarse para alinearse con la liberación nocturna natural de GH de tu cuerpo. La inyección es pequeña (jeringa estilo insulina) y la mayoría de los pacientes se auto-administran en casa después de una breve instrucción. Los sitios se rotan entre el abdomen, muslo y brazo superior." },
          { icon: "📦", title: "Concentraciones Disponibles", table: [
            ["Acetato de Sermorelina", "6 mg", "Vial liofilizado"],
            ["Acetato de Sermorelina", "9 mg", "Vial liofilizado"],
            ["Acetato de Sermorelina", "15 mg", "Vial liofilizado"]
          ], tableNote: "El polvo se reconstituye con agua bacteriostática antes de usar. Tu médico determina la concentración correcta y el protocolo de dosificación para tus necesidades individuales." },
          { icon: "🔬", title: "En Qué Difiere de HGH", desc: "Las inyecciones directas de HGH evitan el circuito de retroalimentación natural de tu cuerpo, lo que puede suprimir tu propia producción y causar efectos secundarios a dosis más altas (dolor articular, retención de líquidos, resistencia a la insulina). Sermorelina trabaja con tu sistema endocrino — tu cuerpo aún controla cuánta GH se libera, haciéndola más segura y más fisiológica a dosis terapéuticas." },
          { icon: "🏭", title: "Estándares de Farmacia", desc: "Compuesto exclusivamente en farmacias 503A registradas por la FDA utilizando ingredientes de grado farmacéutico de proveedores registrados por la FDA. Preparado como un polvo liofilizado estéril en viales individuales de paciente. Este es un medicamento compuesto — no un medicamento aprobado por la FDA — y se dispensa conforme a una prescripción médica válida." }
        ],
        ctaNote: "Comienza tu evaluación médica gratuita"
      },
      howItWorks: {
        label: "El Proceso",
        title: "3 Pasos para el Tratamiento.",
        titleEm: "No se requiere clínica.",
        subtitle: "Desde la admisión hasta la entrega en días — no semanas. Nuestro equipo médico maneja todo.",
        steps: [
          { num: "01", title: "Completa tu Formulario Médico", desc: "Un breve cuestionario de salud seguro HIPAA. Toma menos de 10 minutos y se puede completar desde tu teléfono, en cualquier lugar." },
          { num: "02", title: "Obtén la Aprobación de un Médico", desc: "Un médico licenciado revisa tu perfil y determina la concentración y el protocolo de dosificación de Sermorelina correctos para tus objetivos." },
          { num: "03", title: "Recíbelo en tu Puerta", desc: "Tu Sermorelina se compone en una farmacia registrada por la FDA y se envía discretamente — directamente a tu casa, lista para reconstituir y usar." }
        ],
        ctaNote: "Toma 10 minutos · Revisión médica incluida"
      },
      trust: {
        label: "Estás Protegido",
        title: "Cuidado de Grado Médico.",
        titleEm: "Cero Compromisos.",
        items: [
          { title: "Supervisado por Médico", desc: "Cada plan revisado y aprobado por un médico licenciado antes de que se realice cualquier pedido." },
          { title: "Farmacias Registradas FDA", desc: "Compuesto en instalaciones totalmente acreditadas y registradas por la FDA con los más altos estándares de pureza." },
          { title: "HIPAA Seguro", desc: "Tus datos de salud están completamente encriptados. Embalaje discreto — sin etiquetas médicas en el exterior." },
          { title: "Entregado a tu Puerta", desc: "Envío a nivel nacional. Consultas médicas continuas incluidas. Estamos contigo en cada paso." }
        ]
      },
      finalCta: {
        label: "A Un Paso",
        title: "Tus Mejores Años",
        titleEm: "Están Por Delante.",
        subtitle: "Completa tu formulario de admisión médica en menos de 10 minutos. Nuestro equipo de médicos lo revisará y se comunicará contigo con tu plan personalizado de Sermorelina. Sin obligación, sin visita a clínica.",
        meta: ["Admisión de 10 Minutos", "Sin Compromiso", "100% Privado", "Envío Nacional"]
      },
      footer: {
        links: ["Política de Privacidad", "Términos de Servicio", "Contáctanos"],
        copy: "© 2026 AntiAging by BB · antiagingbybb.com · Todos los derechos reservados."
      },
      disclaimer: "* El Acetato de Sermorelina es un medicamento compuesto y no está aprobado por la FDA. Los medicamentos compuestos se preparan para uso individual del paciente conforme a una prescripción médica válida. Estas declaraciones no han sido evaluadas por la Administración de Alimentos y Medicamentos. Los resultados pueden variar. Todos los tratamientos requieren evaluación y aprobación médica. Los resultados individuales no están garantizados."
    }
  }
};

export function getLandingContent(lang, page) {
  const content = LANDING_CONTENT[lang] || LANDING_CONTENT.en;
  return content[page] || LANDING_CONTENT.en[page];
}
